import 'vue'



// WEBPACK FOOTER //
// ./src/js/vendor.js